/** EmitIQ's analysis from your data (`GET /plan/recommendations`) - the Recommendations tab's read.
 *
 * Deterministic and computed on the server from the company's own figures, census, unaccepted
 * figures and Scope 3 decisions. Thrown on failure, never defaulted to empty: an empty list would
 * say there is nothing to look at, which is the one claim this read must not make by accident.
 */

import { skipToken, useQuery } from "@tanstack/react-query";

import { api } from "./client";
import { refusalFrom } from "./refusal";
import type { components } from "./schema";

export type Recommendations = components["schemas"]["RecommendationsOut"];
export type Recommendation = components["schemas"]["RecommendationOut"];

export function useRecommendations(
  periodStart: string | undefined,
  periodEnd: string | undefined,
  method: "location" | "market",
) {
  return useQuery({
    queryKey: ["plan", "recommendations", periodStart ?? "none", periodEnd ?? "none", method] as const,
    queryFn:
      periodStart && periodEnd
        ? async (): Promise<Recommendations> => {
            const { data, error, response } = await api.GET("/api/v1/plan/recommendations", {
              params: {
                query: { period_start: periodStart, period_end: periodEnd, scope2_method: method },
              },
            });
            if (error || !data) throw refusalFrom(response, error, "The recommendations could not be read.");
            return data;
          }
        : skipToken,
  });
}
